<div class="inner-page-wrapper">
    @if (tabs(); as data) {
        @if (data.length > 1) {
            <div
                class="mt-16 flex gap-20 overflow-auto md:mt-24 md:justify-center md:gap-40 md:overflow-hidden"
                #tabListContainer
                role="tablist"
            >
                @for (item of data; track $index) {
                    <button
                        class="font-headline text-14 text-accent md:text-18 shrink-0 border-b-4 pb-4 leading-27 text-nowrap hover:font-medium"
                        id="showroom-tab-{{ $index }}"
                        #tabListItem
                        [ngClass]="{
                            'border-b-accent font-medium': currentIndex() === $index,
                            'border-b-transparent': currentIndex() !== $index,
                        }"
                        [attr.aria-selected]="currentIndex() === $index"
                        (click)="tabClicked.emit($index)"
                        role="tab"
                    >
                        {{ item }}
                    </button>
                }
            </div>
        }
    }
</div>
